module.exports = __webpack_public_path__ + "img/chevron-down-gray-dark копія.27fa15ea.svg";